'use client';

import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import TabsSlider from '@framework/ui/Pages/Landing/Sections/TabsSlider';
import { visualizeSection, allocateProprietary } from '@/allocate/ui/components/Home/ProcessSection/tabs';
import { IClassNames } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';

import styles from './styles.module.scss';

const classNames: IClassNames = {
  imgClassName: styles.img,
  slidersWrapper: styles.slidersWrapper,
  imgLabelClassName: styles.imgLabelClassName,
};

const ProcessSection = () => (
  <Section padding="top" id="features">
    <SectionContainer className={ styles.section }>
      <SectionHeader
        title={ (
          <>
            <div>Visualize. Analyze. Empower.</div>
            <div>Extract valuable investor insights with Allocate.</div>
          </>
        ) }
        description="Allocate preserves institutional knowledge and helps you understand your investor base across accounts, transactions and time."
        maxWidth={ 915 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <TabsSlider
        descriptionAboveDots={ (
          <div className={ styles.dotsDescription }>
            Allocate integrates and cleans disparate data to build connections across deals and time,
            creating a gold-standard database for you and your deal teams.
          </div>
        ) }
        content={ visualizeSection }
        classNames={ classNames }
      />
      <TabsSlider
        descriptionAboveDots={ (
          <div className={ styles.dotsDescription }>
            Allocate’s proprietary visualizations and granular filters provide deep visibility into investor
            buying patterns throughout your deal lifecycle and across deals.
          </div>
        ) }
        content={ allocateProprietary }
        isReversedPosition
        classNames={ classNames }
      />
    </SectionContainer>
  </Section>
);

export default ProcessSection;
